// O loader do Eldorado Bridge (Stencil, ~400 KB) só é necessário onde o <m4u-eldorado-bridge> é
// renderizado (pagamento com cartão). Fica fora do bundle de entrada e só é baixado quando o
// EldoradoBridge monta; a promise é guardada para os custom elements serem definidos uma única vez.
let loadPromise = null;

export const loadEldoradoBridge = () => {
  if (!loadPromise) {
    loadPromise = import("@meios-pagamentos/eldorado-bridge-component/loader")
      .then(({ applyPolyfills, defineCustomElements }) =>
        applyPolyfills().then(() => defineCustomElements())
      )
      .catch(error => {
        // Libera uma nova tentativa na próxima montagem do componente.
        loadPromise = null;
        throw error;
      });
  }

  return loadPromise;
};

// Começa o download depois do `load`, em idle: quando o usuário chega ao formulário de cartão o
// loader já está no cache. Falha em silêncio (a montagem do EldoradoBridge tenta de novo).
export const prefetchEldoradoBridge = () => {
  const start = () => loadEldoradoBridge().catch(() => {});
  const schedule = () =>
    "requestIdleCallback" in window ? window.requestIdleCallback(start) : setTimeout(start, 2000);

  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
};

export default loadEldoradoBridge;
